export const calenderInitialData = {
  calendarEvents: [
    {
      title: "Atlanta Monster",
      start: new Date("2022-04-04 00:00"),
      id: "1001",
    },
    {
      title: "My Favorite Murder",
      start: new Date("2022-04-05 00:00"),
      id: "1002",
    },
  ],
  events: [
    {
      className: "bg-primary",
      title: "Birthday Party",
      id: "1",
      icon: "fa fa-birthday-cake",
    },
    { className: "bg-primary", title: "Meeting With Team.", id: "2", icon: "fa fa-user" },
    { className: "bg-primary", title: "Tour & Picnic", id: "3", icon: "fa fa-plane" },
    {
      className: "bg-primary",
      title: "Reporting Schedule",
      id: "4",
      icon: "fa fa-file-text",
    },
    {
      className: "bg-primary",
      title: "Lunch & Break",
      id: "5",
      icon: "fa fa-briefcase",
    },
  ],
};
